import React from 'react';

import { InputAdornment, TextField, Typography, useTheme } from '@mui/material';

interface DisabledTextFieldProps {
  title: string;
  displayValue: string;
  endIcon?: React.ReactNode;
  startIcon?: React.ReactNode;
}

const DisabledTextField = ({ title, displayValue, endIcon, startIcon }: DisabledTextFieldProps) => {
  const theme = useTheme();
  return (
    <>
      <Typography variant="h5" sx={{ color: theme.palette.text.disabled, mb: 1, fontSize: '10px' }}>
        {title}
      </Typography>
      <TextField
        disabled
        fullWidth
        id="filled-disabled"
        data-testid={`textfield-${title}`}
        value={displayValue}
        sx={{
          '& .MuiInputBase-input.Mui-disabled': {
            WebkitTextFillColor: '#000',
            fontSize: '12px',
            height: '2px',
          },
          '& .MuiInputBase-root.Mui-disabled': {
            backgroundColor: '#F2F2F2',
          },
          '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
            borderColor: 'transparent',
          },
        }}
        InputProps={{
          ...(startIcon && {
            startAdornment: <InputAdornment position="start">{startIcon}</InputAdornment>,
          }),
          ...(endIcon && {
            endAdornment: <InputAdornment position="start">{endIcon}</InputAdornment>,
          }),
        }}
      />
    </>
  );
};

export default DisabledTextField;
